import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { toast } from 'react-toastify'
import { Trans, useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { LOCALE_OPTIONS } from '../../../misc/Constants'
import { updateCommunityLocale } from '../../../actions/communitiesActions'
import Loader from '../../common/loader/legacy-loaders/Op36Loader-web'
import Select from '../../common/form/Select'
import SubmitButton from '../../common/buttons/SubmitButton'

import classes from './LanguageTab.module.scss'

const LanguageTab = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const currentUser = useSelector(state => state.user.current_user)
  const community = currentUser.communities[0]

  const [locale, setLocale] = useState(community?.locale || 'en')

  if (!community) {
    return <Loader message={t('communitySettings.page.loading')} />
  }

  const handleSave = () => {
    dispatch(updateCommunityLocale(community.id, locale, currentUser.id))
      .then(() => toast.success(t('communitySettings.languageTab.languageUpdated')))
      .catch(() => toast.error(t('communitySettings.common.genericError')))
  }

  return (
    <>
      <div className={classNames('py-4', classes['language-tab'])}>
        <form id='languageSettings' className={classNames('px-3', classes['settings-form'])} onSubmit={(e) => { e.preventDefault(); handleSave() }}>
          <div className='pb-4'>
            <label htmlFor='locale'>{t('common.language')}</label>
            <p className={classNames('mb-2', classes['label-description'])}>
              {t('communitySettings.languageTab.languageHelp')}
              {currentUser.user_settings?.locale && (
                <>
                  {' '}
                  <Trans
                    i18nKey='communitySettings.languageTab.ownLanguageNote'
                    components={{ accountLink: <Link to='/account?editTab=language' /> }}
                  />
                </>
              )}
            </p>
            <Select
              inputId='locale'
              value={LOCALE_OPTIONS.find((option) => option.value === locale)}
              options={LOCALE_OPTIONS}
              onChange={(option) => setLocale(option.value)}
              isSearchable={false}
            />
          </div>
        </form>
      </div>
      <div className={classNames('d-flex justify-content-center align-items-center', classes.footer)}>
        <SubmitButton
          noTopMargin
          buttonMessage={t('common.action.saveChanges')}
          className={classes['save-button']}
          disabled={locale === (community.locale || 'en')}
          form='languageSettings'
        />
      </div>
    </>
  )
}

export default LanguageTab
